
/* TRAPN Flyover for asynchronously loaded native Impulse recommendations */
(function () {
  function initialize(root) {
    var grid = root.querySelector('.product-recommendations-placeholder > .grid');
    if (!grid || grid.dataset.trapnFlyoverReady === '1') return;

    var cards = Array.prototype.filter.call(grid.children, function (el) {
      return el.classList.contains('grid__item');
    });
    if (!cards.length) return;

    var header = root.querySelector('.section-header');
    var railContainer = grid.closest('.product-recommendations-placeholder');
    if (!header || !railContainer) return;

    grid.dataset.trapnFlyoverReady = '1';
    header.classList.add('trapn-flyover-head');

    var arrows = document.createElement('div');
    arrows.className = 'trapn-flyover-arrows';
    arrows.innerHTML = '<button type="button" class="trapn-flyover-arrow" data-prev aria-label="Previous products">&larr;</button><button type="button" class="trapn-flyover-arrow" data-next aria-label="Next products">&rarr;</button>';
    

    var progress = document.createElement('div');
    progress.className = 'trapn-flyover-progress-row';
    progress.innerHTML = '<div class="trapn-flyover-track"><div class="trapn-flyover-thumb"></div></div><span class="trapn-flyover-count">01 / 01</span>';
    railContainer.insertAdjacentElement('afterend', progress);
    progress.insertBefore(arrows, progress.firstChild);

    var prev = arrows.querySelector('[data-prev]');
    var next = arrows.querySelector('[data-next]');
    var thumb = progress.querySelector('.trapn-flyover-thumb');
    var counter = progress.querySelector('.trapn-flyover-count');

    function update() {
      var max = Math.max(0, grid.scrollWidth - grid.clientWidth);
      var x = Math.max(0, Math.min(max, grid.scrollLeft));
      var gap = parseFloat(getComputedStyle(grid).gap) || 0;
      var width = cards[0].getBoundingClientRect().width;
      if (!width) return;

      var visible = Math.min(
        cards.length,
        Math.max(1, Math.floor((grid.clientWidth + gap + 1) / (width + gap)))
      );

      var size = Math.min(100, visible / cards.length * 100);
      var scrollFraction = max > 0
  ? Math.max(0, Math.min(1, x / max))
  : 1;

var fillPercent = size + (100 - size) * scrollFraction;

thumb.style.width = fillPercent + '%';
thumb.style.left = '0%';

      var active = 0;
      var closest = Infinity;

      cards.forEach(function (card, index) {
        var distance = Math.abs(card.offsetLeft - cards[0].offsetLeft - x);
        if (distance < closest) {
          closest = distance;
          active = index;
        }
      });

      counter.textContent =
        String(active + 1).padStart(2, '0') +
        ' / ' +
        String(cards.length).padStart(2, '0');

      prev.disabled = x <= 1;
      next.disabled = x >= max - 1;
      arrows.hidden = max <= 1;
      progress.hidden = max <= 1;
    }

    function move(direction) {
      var gap = parseFloat(getComputedStyle(grid).gap) || 0;

      grid.scrollBy({
        left: direction * (cards[0].getBoundingClientRect().width + gap),
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches
          ? 'auto'
          : 'smooth'
      });
    }

    prev.addEventListener('click', function () {
      move(-1);
    });

    next.addEventListener('click', function () {
      move(1);
    });

    grid.addEventListener('scroll', update, { passive: true });

    if ('ResizeObserver' in window) {
      new ResizeObserver(update).observe(grid);
    } else {
      window.addEventListener('resize', update);
    }

    update();
  }

  function scan() {
    document
      .querySelectorAll('product-recommendations[id^="Recommendations-"]')
      .forEach(initialize);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }

  // Observe replacements performed by Impulse's recommendation loader.
  var pending = false;

  new MutationObserver(function () {
    if (pending) return;
    pending = true;

    requestAnimationFrame(function () {
      pending = false;
      scan();
    });
  }).observe(document.documentElement, {
    childList: true,
    subtree: true
  });

  document.addEventListener('shopify:section:load', scan);
})();